import { http } from 'services/http';
import { CLIENT_INSURANCE, CLIENT_INSURANCE_HISTORY } from 'api/query-keys';
import type { TEntityIdRes, TUpdateClientInsuranceDatesReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base';

export const useUpdateClientInsuranceDates = (clientId: number, insuranceId: number) => {
  return useMutationBase<TEntityIdRes, unknown, TUpdateClientInsuranceDatesReq>({
    mutationFn: async (variables) => {
      const { data } = await http.patch<TEntityIdRes>(`/v1/clients/${clientId}/insurance/${insuranceId}`, variables);

      return data;
    },
    invalidateCallback: () => [
      [CLIENT_INSURANCE, clientId],
      [CLIENT_INSURANCE_HISTORY, clientId],
    ],
  });
};
